import React from "react";
import { useNavigate } from "react-router-dom";
import abouti from "../assets/aboutush.png";

export default function AboutPreview() {
  const navigate = useNavigate();
  return (
    <div className="container py-5">
      <h1 className="text-center display-5 fw-bold">About Us</h1>

      <div className="row align-items-center">
        <div className="col-md-6">
            <img src={abouti} className="img-fluid" alt="About us" />

        </div>
        <div className="col-md-6">
          <p className="fs-5" style={{ textAlign: "justify" }}>At Vizionexl, we are a technology-driven company focused on empowering businesses through smart digital solutions. With expertise in emerging technologies and real-world challenges, we deliver scalable, secure IT services tailored for startups, enterprises, and institutions.
Our team of developers, ethical hackers, designers, and consultants work collaboratively to drive innovation with impact.
We believe every business deserves access to modern digital transformation. By aligning technology with strategy, we help clients stay ahead in a fast-paced digital world.
At Vizionexl, your digital success marks the start of a transformative journey.</p>
          <center><button className="btn btn-primary" onClick={() => navigate("/about")}>Know More</button></center>
        </div>
      </div>
    </div>
  );
}
